import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <p>{t('Footer.Copyright', { year: new Date().getFullYear() })}</p>
    </footer>
  );
};

export default Footer;
